import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
const EmbeddedPreviewSheet = ({ open, onClose, previewLayout = 'desktop', children }) => {
    const isFullWidth = previewLayout !== 'desktop';
    if (!open) {
        return null;
    }
    return (_jsxs(Box, { sx: {
            position: 'absolute',
            inset: 0,
            zIndex: 1,
            pointerEvents: 'auto'
        }, children: [_jsx(Box, { onClick: onClose, sx: {
                    position: 'absolute',
                    inset: 0,
                    bgcolor: 'rgba(0, 0, 0, 0.4)'
                } }), _jsx(Box, { sx: {
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    width: isFullWidth ? '100%' : 500,
                    maxWidth: '100%',
                    bgcolor: '#FFFFFF',
                    boxShadow: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    borderTopLeftRadius: isFullWidth ? 0 : '24px',
                    borderBottomLeftRadius: isFullWidth ? 0 : '24px',
                    transform: 'translateX(0)',
                    animation: 'eventRegistrationSheetSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    '@keyframes eventRegistrationSheetSlideIn': {
                        from: { transform: 'translateX(100%)' },
                        to: { transform: 'translateX(0)' }
                    }
                }, children: children })] }));
};
export default EmbeddedPreviewSheet;
